import React from "react";

const FAQ = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container-custom max-w-5xl">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Frequently asked questions
          </h2>
          <p className="text-gray-600 text-lg">
            Have other questions? Get in touch with our team via{" "}
            <a
              href="mailto:info@estabild.com"
              className="text-primary-600 hover:text-primary-700 underline"
            >
              info@estabild.com
            </a>
          </p>
        </div>

        <div className="space-y-4">
          <FAQItem
            question="How is Estabild different from other project management tools for real estate development?"
            answer={
              <>
                <p className="mb-4">
                  Estabild is <strong>not</strong> a project management tool,
                  but a project financing and development platform.
                </p>
                <p className="mb-4">
                  Our solution is specifically designed for the real estate
                  development industry, with features tailored to the needs of
                  lenders and investors that finance development projects,
                  project developers, technical advisors and inspectors. We
                  offer a comprehensive solution that focuses on project
                  monitoring, financing and planning. Our features include
                  budget tracking, cost control, scheduling, verification of
                  completed work, progress tracking, task management,
                  communication portal and more.
                </p>
                <p>
                  Contact us so we can find the best solution that fits your
                  needs.
                </p>
              </>
            }
          />
          <FAQItem
            question="Could Estabild integrate with tools used in my company?"
            answer={
              <>
                <p className="mb-4">
                  At Estabild we offer integration with Enterprise Resource
                  Planning (ERP), accounting systems and other industry tools.
                  In addition, we have a native integration with MS Excel and
                  can import (almost) any sort of data.
                </p>
                <p>
                  We are happy to integrate with widely adopted systems at no
                  additional cost. If you have a specific system in mind, please
                  do not hesitate to contact us. We are always open to
                  discussion.
                </p>
              </>
            }
          />
          <FAQItem
            question="How many people can I invite to Estabild?"
            answer={
              <>
                <p className="mb-4">As many as you need!</p>
                <p>
                  We believe that collaboration is important to achieve
                  successful project results. Therefore we don't have a limit on
                  a number of project users, and there are no additional costs
                  for new invites.
                </p>
              </>
            }
          />
          <FAQItem
            question="Our project data are sensitive, is there a security risk when using Estabild?"
            answer={
              <>
                <p className="mb-4">
                  Your security is our top priority. At Estabild we hold
                  ourselves to industry-leading privacy standards and take the
                  responsibility of keeping your data secure. Some examples on
                  how we do it:
                </p>
                <ol className="list-decimal list-inside space-y-3 mb-4">
                  <li>
                    We use secure and reliable infrastructure to host data. Data
                    centers are SOC 1, SOC 2, and SOC 3 certified.
                  </li>
                  <li>
                    All personal data are protected with identity management
                    expertise and state of the art security features. We ensure
                    that only the right people can access the information stored
                    in Estabild.
                  </li>
                  <li>
                    Our platform enforces secure password policy to enhance the
                    security of the authentication of the users. Password and
                    sensitive data are stored encrypted using the industry best
                    practices and cryptographic frameworks.
                  </li>
                  <li>
                    All the communication between you and the platform is
                    encrypted and uses strong encryption protocols. This
                    protects the data in transit secure and communication
                    private.
                  </li>
                </ol>
              </>
            }
          />
          <FAQItem
            question="Do you offer a free trial?"
            answer={
              <>
                <p className="mb-4">
                  We can offer a demo account for your team to explore our
                  platform. This will be provided after an introductory call for
                  us to showcase Estabild's features.
                </p>
                <p>
                  Additionally, we can offer a free assessment by using your
                  anonymized project data to showcase how your project would
                  look like in Estabild.
                </p>
              </>
            }
          />
        </div>
      </div>
    </section>
  );
};

// FAQ Item Component
const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <div className="border border-gray-200 rounded-lg overflow-hidden">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors"
      >
        <h3 className="text-lg font-bold text-gray-900 pr-8">{question}</h3>
        <div className="flex-shrink-0">
          <svg
            className={`w-6 h-6 text-gray-900 transition-transform duration-200 ${
              isOpen ? "rotate-45" : ""
            }`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 4v16m8-8H4"
            />
          </svg>
        </div>
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ${
          isOpen ? "max-h-[1000px]" : "max-h-0"
        }`}
      >
        <div className="px-6 pb-6 text-gray-600 leading-relaxed">{answer}</div>
      </div>
    </div>
  );
};

export default FAQ;
